import React, { memo } from 'react';
import OperatorSection from './OperatorSection';

const DataProcessingSection = memo(({
  formData,
  setFormData,
  isEditing = true,
  metadataFields,
  distinctValues
}) => {
  const onlyShowColumns = [
    "instrument",
    "study"
  ]
  return (
    <div className="bg-white rounded-lg shadow p-4 lg:p-6">
      <h2 className="text-lg font-semibold mb-4">Data Processing</h2>

      {/* Filter Data */}
      <OperatorSection
        title="Filter Data"
        description="Unified filter system for data filtering in JSON format"
        filters={formData.filter_data}
        sectionKey="filter_data"
        formData={formData}
        setFormData={setFormData}
        isEditing={isEditing}
        metadataFields={metadataFields}
        distinctValues={distinctValues}
        onlyShowColumns={onlyShowColumns}
      />

      {/* Fill N/A */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Fill N/A</label>
        <input
          type="number"
          className="w-32 border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          value={formData.fill_na}
          min={-Infinity}
          onChange={(e) => {
            const val = e.target.value;
            setFormData({
              ...formData,
              fill_na: val === '' ? '' : Number(val)
            });
          }}
          disabled={!isEditing}
        />
      </div>
    </div>
  );
});

DataProcessingSection.displayName = 'DataProcessingSection';

export default DataProcessingSection;
